import api from '@/common/api';
import { calculateTotalPage } from '@/common/util';

const initialState = () => ({
  allBasketsUsers: [],
  basketUser: {
    id: null,
    items: [],
    total_price: 0,
    items_count: 0,
  },
  filters: {
    allBasketsUsers: {
      name: '',
      status: '',
      email: '',
      nomenclature_code: '',
    },
    allOrders: {
      name: '',
      status: '',
      email: '',
      nomenclature_code: '',
    }
  },
  pagination: {
    allBasketsUsers: {
      count: 0,
      page: 1,
      page_size: 10,
      total_page: 0,
      ordering: '',
    },
    allOrders: {
      count: 0,
      page: 1,
      page_size: 10,
      total_page: 0,
      ordering: '',
    },

  },
  allOrders: [],
  detailOrder: {},
  loadingBasketPage: false,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    // basket
    async fetchAllBaskets({ commit, getters }) {
      try {
        commit('SET_LOADING', true);
        const params = getters.queryParams('allBasketsUsers');
        const response = await api.get('/service-catalog/shopping-cart/', { params });
        const {
         results, count, next, previous
        } = await response;
        // eslint-disable-next-line camelcase
        const { page_size, page } = getters.pagination('allBasketsUsers');
        const totalPage = calculateTotalPage({ count, page_size });
        commit('SET_PAGINATION', {
          name: 'allBasketsUsers', count, next, previous, totalPage, page_size, page
        });
        commit('SET_ALL_BASKETS', results);
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async setFiltersAllBaskets({ dispatch, commit }, filters) {
      commit('SET_FILTERS', filters);
      await dispatch('fetchAllBaskets', `?page=${filters.page}&page_size=${filters.itemsPerPage}`);
    },
    async fetchUserBasket({ commit }) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get('/service-catalog/shopping-cart/my-cart/');
        commit('SET_USER_BASKET', { ...response, items: response.items.sort((a, b) => a.id - b.id) });
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async addToBasket({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post('/service-catalog/shopping-cart/', payload);
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async changeCount({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.patch(`/service-catalog/cart-items/${payload.id}/`, payload);
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async removeFromBasket({ commit }, id) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/service-catalog/cart-items/${id}/`);
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async clearBasket({ commit }) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete('/service-catalog/shopping-cart/clear/');
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // order
    async createOrder({ commit }) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post('/service-catalog/shopping-cart/checkout/');
        return response;
      } catch (error) {
        console.error('Error fetching user basket:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchAllOrders({ commit, getters }) {
      try {
        commit('SET_LOADING', true);
        const params = getters.queryParams('allOrders');
        const response = await api.get('/service-catalog/purchases/', {
          params
        });
        if (response && response?.results.length > 0) {
          const {
            results, count, next, previous
          } = response;
          // eslint-disable-next-line camelcase
          const { page_size, page } = getters.pagination('allOrders');
          const totalPage = calculateTotalPage({ count, page_size });
          commit('SET_PAGINATION', {
            name: 'allOrders', count, next, previous, totalPage, page_size, page
          });
          commit('SET_ALL_ORDERS', results);
        }
        return response;
      } catch (error) {
        console.error('Error fetching users purchases:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async setPaginationOrders({ commit, dispatch }, payload) {
      try {
        commit('SET_LOADING', true);
        commit('SET_PAGINATION', payload);
        await dispatch('fetchAllOrders');
      } catch (error) {
        console.error('Error setPagination:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async setPaginationBaskets({ commit, dispatch }, payload) {
      try {
        commit('SET_LOADING', true);
        commit('SET_PAGINATION', payload);
        await dispatch('fetchAllBaskets');
      } catch (error) {
        console.error('Error setPagination:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchDetailOrder({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get(`/service-catalog/purchases/${payload.id}/`);
        return response;
      } catch (error) {
        console.error('Error fetching detail order:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async toggleChecked({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.patch(`/service-catalog/cart-items/${payload.id}/toggle/`, payload);
        return response;
      } catch (error) {
        console.error('Error fetching detail order:', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
  mutations: {
    SET_USER_BASKET(state, basket) {
      state.basketUser = basket;
    },
    SET_LOADING(state, isLoading) {
      state.loadingBasketPage = isLoading;
    },
    SET_ALL_BASKETS(state, baskets) {
      state.allBasketsUsers = baskets;
    },
    SET_FILTERS(state, payload) {
      state.filters[payload.name] = payload;
    },
    SET_PAGINATION(state, payload) {
      state.pagination[payload.name] = { ...payload };
    },
    SET_ALL_ORDERS(state, orders) {
      state.allOrders = orders;
    },

  },
  getters: {
    allBasketsUsers: (state) => state.allBasketsUsers,
    basketUser: (state) => state.basketUser,
    itemInBasket: (state) => (itemId) => state.basketUser.items.find(item => item.service_card_id === itemId),
    hasItemsInBasket: (state) => state.basketUser.items_count > 0,
    loading: (state) => state.loadingBasketPage,
    allOrders: (state) => state.allOrders,
    // Pagination && Filters
    queryParams: (state) => (field) => {
      const params = { ...state.filters[field], ...state.pagination[field] };
      Object.keys(params).forEach(key => {
        const hiddenField = ['count', 'total_page', 'name', 'next', 'previous', 'totalPage'];
        if (params[key] === null || params[key] === '' || params[key] === undefined || hiddenField.includes(key)) {
          delete params[key];
        }
      });
      console.log(params);
      return params;
    },
    pagination: (state) => (field) => state.pagination[field],
    filters: (state) => (field) => state.filters[field],
  },
};
